module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "64",
      "height": "64",
      "viewBox": "0 0 64 64",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "32",
      "cy": "32",
      "r": "32",
      "fill": "#E8E8E8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.6309 11.4422L22.4246 9.64844H42.1555L44.8461 12.339V52.6978L42.1555 54.4915H23.3214L20.6309 52.6978V11.4422Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35.1771 30.7344H29.7334V32.9137H35.1771V30.7344Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.3",
      "d": "M30.8271 32.9131V30.7344H31.3725L30.8271 32.9131Z",
      "fill": "#5C0617"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.3",
      "d": "M34.0913 32.9131V30.7344H33.5459L34.0913 32.9131Z",
      "fill": "#5C0617"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.2678 29.098V34.7692C36.2679 34.8668 36.2422 34.9628 36.1933 35.0473C36.1443 35.1318 36.0739 35.2018 35.9892 35.2502L34.3724 36.175C34.3438 36.1919 34.3113 36.2009 34.2781 36.2011C34.2449 36.2012 34.2122 36.1925 34.1835 36.1759C34.1548 36.1592 34.1311 36.1351 34.1147 36.1062C34.0984 36.0773 34.0901 36.0445 34.0907 36.0113V29.098C34.0912 28.6723 33.9256 28.2631 33.6292 27.9576C33.3328 27.6522 32.929 27.4745 32.5037 27.4625C32.0784 27.4505 31.6652 27.6051 31.3521 27.8934C31.039 28.1816 30.8506 28.5808 30.8271 29.0059C30.8271 28.9835 30.8271 28.9611 30.8271 28.9387C30.8301 28.8948 30.8338 28.8506 30.8383 28.8062C30.8383 28.7844 30.8433 28.7626 30.8458 28.7408L30.8551 28.6786C30.8589 28.6568 30.862 28.6357 30.8657 28.6164C30.8738 28.5741 30.8825 28.5311 30.8918 28.4888C30.8968 28.4683 30.9024 28.4471 30.9074 28.4266C30.9123 28.406 30.9179 28.3849 30.9242 28.3643C30.9304 28.3438 30.936 28.3214 30.9434 28.3021C30.9509 28.2828 30.9553 28.2629 30.9615 28.2442C30.9931 28.1488 31.0303 28.0553 31.0728 27.9642C31.0796 27.948 31.0877 27.9312 31.0958 27.9156C31.1039 27.9001 31.1033 27.8995 31.1076 27.8914C31.1169 27.8727 31.1269 27.854 31.1362 27.8347C31.1888 27.7364 31.2472 27.6412 31.311 27.5497C31.3296 27.5223 31.3489 27.4956 31.3682 27.4695C31.4444 27.3676 31.5275 27.2711 31.6169 27.1807C31.9891 26.8082 32.4612 26.5516 32.9761 26.4422C33.491 26.3328 34.0266 26.3752 34.5179 26.5642C35.0092 26.7532 35.4352 27.0808 35.7443 27.5072C36.0533 27.9337 36.2321 28.4407 36.2591 28.9667C36.2672 29.0047 36.2678 29.0514 36.2678 29.098Z",
      "fill": "url(#paint0_linear_9839_11418)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.2657 28.968C36.2388 28.4419 36.06 27.9349 35.7509 27.5085C35.4419 27.0821 35.0159 26.7545 34.5246 26.5654C34.0333 26.3764 33.4977 26.334 32.9828 26.4435C32.4679 26.5529 31.9957 26.8094 31.6236 27.182C31.5341 27.2724 31.451 27.3689 31.3748 27.4707C31.3556 27.4968 31.3363 27.5236 31.3176 27.551C31.2538 27.6425 31.1955 27.7376 31.1429 27.836C31.1336 27.8553 31.1236 27.874 31.1143 27.8926C31.1099 27.9007 31.1062 27.9088 31.1025 27.9169L31.0913 27.9399C31.0453 28.038 31.0048 28.1386 30.97 28.2411C30.9625 28.2617 30.9557 28.2828 30.9501 28.3034C30.9445 28.3239 30.9364 28.3469 30.9308 28.3656C30.9252 28.3843 30.919 28.4073 30.914 28.4278C30.9091 28.4484 30.9028 28.4701 30.8985 28.4901C30.8885 28.5317 30.8798 28.5747 30.8724 28.6176C30.868 28.6394 30.8643 28.6606 30.8618 28.6799C30.8593 28.6991 30.855 28.7228 30.8525 28.7421C30.85 28.7614 30.8463 28.7856 30.845 28.8074C30.8394 28.851 30.8363 28.8952 30.8338 28.94C30.8338 28.968 30.8307 28.9954 30.8301 29.024C30.8301 29.0308 30.8301 29.0383 30.8301 29.0458C30.8301 29.0638 30.8301 29.0819 30.8301 29.0993V36.0206C30.8306 36.0539 30.8223 36.0866 30.806 36.1156C30.7897 36.1445 30.7659 36.1685 30.7372 36.1852C30.7085 36.2019 30.6759 36.2106 30.6427 36.2104C30.6095 36.2103 30.5769 36.2013 30.5484 36.1843L28.9316 35.2596C28.8467 35.2112 28.7761 35.1413 28.7271 35.0568C28.678 34.9723 28.6522 34.8762 28.6523 34.7785V29.1777C28.6523 27.0618 30.3792 25.282 32.4904 25.297C33.4718 25.3035 34.4127 25.6891 35.1169 26.3732C35.821 27.0573 36.2339 27.9871 36.2695 28.9686L36.2657 28.968Z",
      "fill": "url(#paint1_linear_9839_11418)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.4527 39.442V41.4956C32.3141 41.4957 32.1776 41.4608 32.056 41.3941L30.9491 40.7619L27.532 38.8072L25.8648 37.8538C25.7099 37.7652 25.5812 37.6372 25.4918 37.4828C25.4023 37.3284 25.3553 37.153 25.3555 36.9745V26.3734C25.3555 25.7957 25.5848 25.2417 25.993 24.8333C26.4011 24.4248 26.9547 24.1953 27.532 24.1953V36.6291L32.4527 39.442Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25.993 24.8333C25.5848 25.2417 25.3555 25.7957 25.3555 26.3734H27.532V24.1953C26.9547 24.1953 26.4011 24.4248 25.993 24.8333Z",
      "fill": "url(#paint2_linear_9839_11418)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39.5015 24.2015V37.0081C39.5018 37.1865 39.455 37.3618 39.3659 37.5163C39.2768 37.6708 39.1486 37.799 38.9941 37.888L37.3269 38.8402L34.5391 40.4352L32.8501 41.3997C32.7283 41.4669 32.5913 41.5021 32.4521 41.5018V39.4482L37.325 36.6615V23.8649C37.2448 23.3518 36.984 22.8843 36.5897 22.5466C36.1955 22.209 35.6936 22.0234 35.1746 22.0234H37.325C37.9023 22.0234 38.4559 22.2529 38.864 22.6614C39.2722 23.0699 39.5015 23.6239 39.5015 24.2015Z",
      "fill": "#F5103B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.8472 41.3951L34.5362 40.4305V38.25L32.4492 39.4435V41.4971C32.5884 41.4974 32.7253 41.4623 32.8472 41.3951Z",
      "fill": "url(#paint3_linear_9839_11418)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M37.3262 23.863V24.2003H27.532C26.9547 24.2003 26.4011 24.4298 25.993 24.8382C25.5848 25.2467 25.3555 25.8007 25.3555 26.3784V24.2003C25.3555 24.0893 25.3639 23.9784 25.3803 23.8686C25.3859 23.8325 25.3928 23.7964 25.3996 23.7609C25.4213 23.6552 25.4508 23.5512 25.4879 23.4498C25.4997 23.4168 25.5128 23.3838 25.5265 23.3515C25.7487 22.8301 26.1642 22.4152 26.6856 22.194C26.7173 22.1803 26.7478 22.1672 26.7839 22.1554C26.8853 22.1185 26.9892 22.0889 27.0948 22.067C27.1302 22.0602 27.1663 22.0539 27.2018 22.0483C27.3115 22.0318 27.4223 22.0235 27.5332 22.0234H35.1758C35.6945 22.0234 36.1962 22.2086 36.5904 22.5459C36.9847 22.8832 37.2456 23.3502 37.3262 23.863Z",
      "fill": "url(#paint4_linear_9839_11418)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M37.3251 24.1979V23.861C37.246 23.2954 36.9197 22.819 36.5249 22.482C36.1301 22.1451 35.6278 22.0234 35.1084 22.0234V24.1979H37.3251Z",
      "fill": "url(#paint5_linear_9839_11418)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.0213 50.0234H23.5081C23.3086 50.0234 23.1172 50.1027 22.9762 50.2438C22.8351 50.3848 22.7559 50.5761 22.7559 50.7756C22.7559 50.9751 22.8351 51.1665 22.9762 51.3075C23.1172 51.4486 23.3086 51.5278 23.5081 51.5278H28.0213C28.2208 51.5278 28.4121 51.4486 28.5532 51.3075C28.6943 51.1665 28.7735 50.9751 28.7735 50.7756C28.7735 50.5761 28.6943 50.3848 28.5532 50.2438C28.4121 50.1027 28.2208 50.0234 28.0213 50.0234Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.0357 50.0234H30.2835C30.084 50.0234 29.8926 50.1027 29.7516 50.2438C29.6105 50.3848 29.5312 50.5761 29.5312 50.7756C29.5312 50.9751 29.6105 51.1665 29.7516 51.3075C29.8926 51.4486 30.084 51.5278 30.2835 51.5278H31.0357C31.2352 51.5278 31.4265 51.4486 31.5676 51.3075C31.7086 51.1665 31.7879 50.9751 31.7879 50.7756C31.7879 50.5761 31.7086 50.3848 31.5676 50.2438C31.4265 50.1027 31.2352 50.0234 31.0357 50.0234Z",
      "fill": "#060606"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.5669 7.89844H23.514C22.5168 7.89956 21.5608 8.29617 20.8557 9.00125C20.1507 9.70634 19.754 10.6623 19.7529 11.6595V50.7742C19.754 51.7713 20.1507 52.7273 20.8557 53.4324C21.5608 54.1375 22.5168 54.5341 23.514 54.5352H41.5669C42.564 54.5341 43.52 54.1375 44.2251 53.4324C44.9302 52.7273 45.3268 51.7713 45.3279 50.7742V11.6595C45.3268 10.6623 44.9302 9.70634 44.2251 9.00125C43.52 8.29617 42.564 7.89956 41.5669 7.89844ZM37.6406 9.40285L37.1892 11.6595H27.8917L27.4404 9.40285H37.6406ZM43.8235 50.7742C43.8228 51.3725 43.5849 51.9461 43.1618 52.3691C42.7388 52.7922 42.1652 53.0301 41.5669 53.0308H23.514C22.9157 53.0301 22.3421 52.7922 21.919 52.3691C21.496 51.9461 21.258 51.3725 21.2573 50.7742V11.6595C21.258 11.0612 21.496 10.4876 21.919 10.0645C22.3421 9.64149 22.9157 9.40352 23.514 9.40285H25.9061L26.5374 12.5592C26.5715 12.7297 26.6636 12.8832 26.7981 12.9934C26.9326 13.1036 27.1011 13.1639 27.275 13.1639H37.8059C37.9798 13.1639 38.1483 13.1036 38.2828 12.9934C38.4173 12.8832 38.5094 12.7297 38.5435 12.5592L39.1748 9.40285H41.5669C42.1652 9.40352 42.7388 9.64149 43.1618 10.0645C43.5849 10.4876 43.8228 11.0612 43.8235 11.6595V50.7742Z",
      "fill": "#060606",
      "stroke": "#E8E7E5",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "id": "paint0_linear_9839_11418",
      "x1": "33.2325",
      "y1": "30.6874",
      "x2": "29.3619",
      "y2": "28.4241",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint1_linear_9839_11418",
      "x1": "1322.95",
      "y1": "2856.38",
      "x2": "1301.39",
      "y2": "3550.14",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint2_linear_9839_11418",
      "x1": "27.1289",
      "y1": "24.1953",
      "x2": "26.4671",
      "y2": "27.161",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.7817",
      "stop-color": "#F5103B"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint3_linear_9839_11418",
      "x1": "32.4492",
      "y1": "40.5248",
      "x2": "35.0499",
      "y2": "39.5543",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.7817",
      "stop-color": "#F5103B"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint4_linear_9839_11418",
      "x1": "2597.03",
      "y1": "417.539",
      "x2": "3559.19",
      "y2": "357.2",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#F5103B"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#7B081E"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "paint5_linear_9839_11418",
      "x1": "36.9979",
      "y1": "22.7782",
      "x2": "34.9184",
      "y2": "23.9024",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#B80B2C"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.743839",
      "stop-color": "#F5103B"
    }
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09ad6887", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09ad6887","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/icons/UpsellDashlane.vue
// module id = 1111
// module chunks = 0